var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('c-ltk-avatar',{directives:[{name:"test-id",rawName:"v-test-id",value:('avatar'),expression:"'avatar'"}],attrs:{"size":_vm.size,"src":_setup.avatarUrl,"alt":_setup.altText,"crossorigin":false,"width":_vm.size,"height":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }